import { ContentModule } from '@alfresco/adf-content-services';
import { CoreModule, TranslationService } from '@alfresco/adf-core';
import { ExtensionService, provideExtensionConfig, RuleContext } from '@alfresco/adf-extensions';
import { NgModule } from '@angular/core';
import { LoansComponent } from './components/loans/loans.component';
import { TransfersComponent } from './components/transfers/transfers.component';
import { RecordsComponent } from './components/records/records.component';
import { AdministrationComponent } from './components/administration/administration.component';
import { UDeuHomeComponent } from './components/home/home.component';
import { CreateRecordDialogComponent } from './dialogs/records/create-record/create-record.dialog';
import { UdeuService } from './services/udeu.service';
import { EffectsModule } from '@ngrx/effects';
import { AttachFilesComponent } from './components/attach-files/attach-files.component';
import { LocationsComponent } from './dialogs/records/create-record/locations/locations.component';
import { AuthorsComponent } from './dialogs/records/create-record/authors/authors.component';
import { RecordEffects } from './store/effects/record.effects';
import { AldenExtensionModule } from 'projects/alden-extension/src/public-api';
import { CreateRecordGaudeDialogComponent } from './dialogs/records/create-record-gaude/create-record-gaude.dialog';
import { OrganizeRecordDialogComponent } from './dialogs/records/organize/organize-record.dialog';
import { DeustoMaterialModule } from './material.module';
import { TransferEffects } from './store/effects/transfer.effects';
import { RecordService } from './services/record.service';
import { TransferService } from './services/transfer.service';
import { CreateTransferCalendarDialogComponent } from './dialogs/transfers/create-transfer-calendar/create-transfer-calendar.dialog';
import { RecipientsComponent } from './dialogs/transfers/create-transfer-calendar/recipients/recipients.component';
import { CreateTransferDialogComponent } from './dialogs/transfers/create-transfer/create-transfer.dialog';
import { DocumentsComponent } from './dialogs/transfers/create-transfer/documents/documents.component';
import { TransferCalendarComponent } from './components/transfer-calendar/transfer-calendar.component';
import { LoanEffects } from './store/effects/loan.effects';
import { LoanService } from './services/loan.service';
import { CreateRecordFormacionDialogComponent } from './dialogs/records/create-record-formacion/create-record-formacion.dialog';
import { CreateLoanDialogComponent } from './dialogs/loans/create-loan/create-loan.dialog';
import { RegistersComponent } from './dialogs/loans/create-loan/registers/registers.component';
import { LoansRegisterComponent } from './dialogs/records/create-record/loans/loans.component';
import { LoanRenewDialogComponent } from './dialogs/loans/create-loan/renew/renew.dialog';
import { BoudComponent } from './components/boud/boud.component';
import { BoudEffects } from './store/effects/boud.effects';
import { BoudService } from './services/boud.service';
import { CreateBoudDialogComponent } from './dialogs/boud/create-boud/create-boud.dialog';
import { BoudElementsComponent } from './dialogs/boud/create-boud/elements/elements.component';
import { RouterModule } from '@angular/router';
import { routes } from '../deusto.routes';

import { PipeServiceImpl } from './services/pipe-service-impl';
import { IntegrationServiceImpl } from './services/integration-service-impl';

import * as rules from './rules/udeu.rules';
import * as recordRules from './rules/record.rules';
import * as transferRules from './rules/transfer.rules';
import * as loanRules from './rules/loan.rules';
import * as boudRules from './rules/boud.rules';
import { PublicationInfoComponent } from './dialogs/boud/create-boud/publication-info/publication-info.component';
import { BoudRegisterComponent } from './dialogs/records/create-record/bouds/boud-elements.component';
import { BoudElementFormComponent } from './dialogs/boud/create-boud/elements/element-form/element-form.component';

@NgModule({
  declarations: [
    UDeuHomeComponent,
    LoansComponent,
    TransfersComponent,
    RecordsComponent,
    AdministrationComponent,
    CreateRecordDialogComponent,
    CreateRecordGaudeDialogComponent,
    CreateRecordFormacionDialogComponent,
    CreateLoanDialogComponent,
    AttachFilesComponent,
    LocationsComponent,
    AuthorsComponent,
    OrganizeRecordDialogComponent,
    CreateTransferCalendarDialogComponent,
    RecipientsComponent,
    CreateTransferDialogComponent,
    DocumentsComponent,
    TransferCalendarComponent,
    RegistersComponent,
    LoansRegisterComponent,
    LoanRenewDialogComponent,
    BoudComponent,
    CreateBoudDialogComponent,
    BoudElementsComponent,
    PublicationInfoComponent,
    BoudRegisterComponent,
    BoudElementFormComponent
  ],
  imports: [
    RouterModule.forChild(routes),
    EffectsModule.forFeature([RecordEffects, TransferEffects, LoanEffects, BoudEffects]),
    CoreModule.forChild(),
    ContentModule.forChild(),
    DeustoMaterialModule,
    AldenExtensionModule
  ],
  providers: [
    provideExtensionConfig(['deusto.extension.json', 'deusto-viewers.extension.json']),
    UdeuService,
    RecordService,
    TransferService,
    LoanService,
    BoudService,
    PipeServiceImpl,
    IntegrationServiceImpl
  ]
})
export class DeustoExtensionModule {
  constructor(private extensions: ExtensionService, private translation: TranslationService, private udeuService: UdeuService) {
    this.translation.addTranslationFolder('deusto-extension', 'assets/deusto-extension');

    /*this.extensions.setComponents({
      'udeu-home': UDeuHomeComponent,
      'module-boud': BoudComponent,
      'module-loans': LoansComponent,
      'module-transfer-calendar': TransferCalendarComponent,
      'module-transfers': TransfersComponent,
      'module-records': RecordsComponent,
      'module-administration': AdministrationComponent
    });

    this.extensions.setAuthGuards({
      'udeu-guard': UDeuGuard,
    });*/

    this.extensions.setEvaluators({
      // modules
      'deusto.canBoud': rules.canBoud,
      'deusto.canLoans' : rules.canLoans,
      'deusto.canTransfers' : rules.canTransfers,
      'deusto.canTransferCalendar' : rules.canTransferCalendar,
      'deusto.canRecords' : rules.canRecords,
      'deusto.canAdministration' : rules.canAdministration,

      // context
      'deusto.canAddFavorite': rules.canAddFavorite,
      'deusto.canDownloadSelection': rules.canDownloadSelectionUdeu,
      'deusto.canEditFolder': rules.canEditFolderUdeu,
      'deusto.canCopyNode': rules.canCopyNodeUdeu,
      'deusto.canDeleteSelectionUdeu': rules.canDeleteSelectionUdeu,
      'deusto.canEditAspects': rules.canEditAspectsUdeu,
      'deusto.canManagePermissions': rules.canManagePermissionsUdeu,
      'deusto.canManageFolderRules': rules.canManageFolderRulesUdeu,
      'deusto.canExcelExport': rules.canExcelExport,

      // records
      'deusto.navigation.isRecordsViewer': recordRules.isRecordsViewer,
      'deusto.canCreateRecords' : recordRules.canCreateRecords,
      'deusto.canViewRecord': recordRules.canViewRecord,
      'deusto.canEditRecord': recordRules.canEditRecord,
      'deusto.canDuplicateRecord': recordRules.canDuplicateRecord,
      'deusto.canDeleteRecord': recordRules.canDeleteRecord,
      'deusto.canEditMassiveRecord': recordRules.canEditMassiveRecord,
      'deusto.canAssignLoan': recordRules.canAssignLoan,
      'deusto.canExportRegisterFile': recordRules.canExportRegisterFile,
      'deusto.canSearchByCreator' :  () => {
        return recordRules.canSearchByCreator(this.udeuService.profile);
      },

      // transfers
      'deusto.navigation.isTransferCalendarViewer' : transferRules.isTransferCalendarViewer,
      'deusto.navigation.isTransfersViewer' : transferRules.isTransfersViewer,
      'deusto.canCreateTransferCalendar' : transferRules.canCreateTransferCalendar,
      'deusto.canCreateTransfer' : transferRules.canCreateTransfer,
      'deusto.canViewCalendarTransfer': transferRules.canViewCalendarTransfer,
      'deusto.canEditCalendarTransfer': transferRules.canEditCalendarTransfer,
      'deusto.canDeleteCalendarTransfer': transferRules.canDeleteCalendarTransfer,
      'deusto.canEditTransfer': (context: RuleContext) => {
          return transferRules.canEditTransfer(context, this.udeuService.personDetails);
      },
      'deusto.canValidateTransfer': transferRules.canValidateTransfer,
      'deusto.canCatalogTransfer': transferRules.canCatalogTransfer,
      'deusto.canEditCatalogTransfer': transferRules.canEditCatalogTransfer,
      'deusto.canViewTransfer': transferRules.canViewTransfer,
      'deusto.canUnlockEditTransfer': (context: RuleContext) => {
        return transferRules.canUnlockEditTransfer(context, this.udeuService.personDetails);
      },
      'deusto.canDeleteTransfer': transferRules.canDeleteTransfer,

      // loans
      'deusto.navigation.isLoansViewer': loanRules.isLoansViewer,
      'deusto.canCreateLoan' : loanRules.canCreateLoan,
      'deusto.canViewLoan': loanRules.canViewLoan,
      'deusto.canEditLoan': loanRules.canEditLoan,
      'deusto.canValidateLoan': loanRules.canValidateLoan,
      'deusto.canAssignRegister': loanRules.canAssignRegister,
      'deusto.canGrantLoan': loanRules.canGrantLoan,
      'deusto.canReturnLoan': loanRules.canReturnLoan,
      'deusto.canRenewLoan': (context: RuleContext) => {
        return loanRules.canRenewLoan(context, this.udeuService.personDetails);
      },
      'deusto.canValidateRenewLoan': loanRules.canValidateRenewLoan,
      'deusto.canDeleteLoan': loanRules.canDeleteLoan,
      'deusto.canManageLoan': () => {
        return loanRules.canManageLoan(this.udeuService.profile);
      },
      'deusto.canFinishLoan': loanRules.canFinishLoan,

      // BOUD
      'deusto.navigation.isBoudViewer': boudRules.isBoudViewer,
      'deusto.canCreateBoud' : boudRules.canCreateBoud,
      'deusto.canViewBoud': boudRules.canViewBoud,
      'deusto.canEditBoud': boudRules.canEditBoud,
      'deusto.canValidateBoud': boudRules.canValidateBoud,
      'deusto.canGeneratePdfBoud': boudRules.canGeneratePdfBoud,
      'deusto.canPublishBoud': boudRules.canPublishBoud,
      'deusto.canDeleteBoud': boudRules.canDeleteBoud,
    });
  }

}